import { commonMistakeCodes, passCodes } from '../passCodes';
import track5 from '../../../../assets/audio/tracks/track5.mp3';

const hints = [
    {
        text: 'Zkuste kouknout za roh.',
    },
    {
        text: 'Jedná se o místo, kde se cvičí a je vedle městského divadla.',
    },
    {
        text: 'Kódem je: sokol',
        solution: true,
    },
];
export const step5bird = {
    id: 5,
    title: '2. stanoviště',
    taskText: `
        <p>
            Víš, že tady dřív stála základní škola? Do téhle obří budovy spoustu let chodilo hóódně dětí, které mě drbaly a dávaly mi kousky ze svačin.
        </p>
        <p>    
            Ty časy jsou už ale nějakej pátek pryč. Ještě předtím, než tu byla škola, tu stával obecní úřad a šatlava. No, co už. 
        </p>
        <p>    
            A co dál? Hej, stačilo mi jen osm kroků a hned už vidím dalšího ptáka. Tak pojďme za ním.
        </p>
    `,
    cipher: {
        text: 'Míša zašel kousek za roh a v dálce uviděl ptáka, zadejte jeho jméno.',
        label: 'Úkol',
    },
    catImage: 1,
    audio: track5,
    snowAudio: track5,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[2],
    additionalInfo: 'Odpovědí je jedno slovo.',
    codeInputPassCodeCommonMistakeRegexp: [commonMistakeCodes[0], commonMistakeCodes[1]],
    codeInputPassCodeCommonMistakeMessage: ['Jsi blízko, ale dojdi klidně blíž.', 'Řekl jsem zajít za roh.'],
    hints: hints,
    snowHints: hints,
};
